<template>
  <p>请在PC端上登录</p>
</template>

<script>
export default {

}
</script>

<style>
p{
    text-align: center;
    line-height: 100vh;
}
</style>